
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/daily-quotes-subscription",
      function () {
        return require("private-next-pages/[region]/[language]/daily-quotes-subscription/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/daily-quotes-subscription"])
      });
    }
  